import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import VueRouter from 'vue-router';

// 进度条
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '@/store/index';
import util from '@/libs/util.js';

// 路由数据
import routes, { frameInRoutes, frameOutRoutes } from './routes';

// fix vue-router NavigationDuplicated
var VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch(function (err) {
    return err;
  });
};
var VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch(function (err) {
    return err;
  });
};
Vue.use(VueRouter);

// 导出路由 在 main.js 里使用
var router = new VueRouter({
  routes: [].concat(_toConsumableArray(frameInRoutes), _toConsumableArray(frameOutRoutes))
});

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var token;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return store.dispatch('d2admin/page/isLoaded');
        case 1:
          _context.n = 2;
          return store.dispatch('d2admin/size/isLoaded');
        case 2:
          // 进度条
          NProgress.start();
          // 关闭搜索面板

          store.commit('d2admin/search/set', false);
          // 验证当前路由所有的匹配中是否需要有登录验证的
          if (to.matched.some(function (r) {
            return r.meta.auth;
          })) {
            // 这里暂时将cookie里是否存有token作为验证是否登录的条件
            // 请根据自身业务需要修改
            token = util.cookies.get('token');
            if (token && token !== 'undefined') {
              next();
            } else {
              // 没有登录的时候跳转到登录界面
              // 携带上登陆成功之后需要跳转的页面完整路径
              next({
                name: 'login',
                query: {
                  redirect: to.fullPath
                }
              });
              // https://github.com/d2-projects/d2-admin/issues/138
              NProgress.done();
            }
          } else {
            // 不需要身份校验 直接通过
            next();
          }
        case 3:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function (to) {
  // 进度条
  NProgress.done();
  // 多页控制 打开新的页面
  store.dispatch('d2admin/page/open', to);
  // 更改标题
  util.title(to.meta.title);
});
export default router;